module.exports = __webpack_public_path__ + "img/DK19956075.9edd1903.png";